import { render, staticRenderFns } from "./ScoreDetails.vue?vue&type=template&id=5f051bc1&scoped=true&"
import script from "./ScoreDetails.vue?vue&type=script&lang=js&"
export * from "./ScoreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f051bc1",
  null
  
)

export default component.exports